<template>
  <div>
    <section class="multi-filter-section">
      <div class="container-row">
        <div class="multi-filter-main-wrapp " :class="{ 'layout-2': isDayViewActive }">
          <div class="multi-agenda-tab">
            <div class="multi-agenda-row">
              <div class="multi-agenda-col" :id="day.startDate.replace(/\//g, '-')" v-for="(day, index) in days"
                v-bind:key="day.id" v-on:click="showAgendaByDay(day.startDate)">
                <div class="multi-agenda-date" :class="{ active: day.startDate === currentHashId }"
                  :agenda-data-tab="'agenda-tab-' + (index + 1)" v-if="checkAnyAgendas(day.startDate)">
                  <h6>{{ day.dayname }} {{ getDayOfMonth(day.startDate) }}</h6>
                  <h5>{{ getMonthName(day.startDate) }}</h5>
                </div>
              </div>
              <div class="multi-agenda-col multi-agenda-col-left">
                <label class="multi-filter-selector">Week View
                  <input type="checkbox" class="view-change-week" @click="toggleView()" />
                  <span class="multi-filter-checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <!-- clear filter starts -->
          <div class="multi-clear-wrapper ">
            <!-- <div class="clear-all-multy">
          clear all
      </div> -->
            <!-- <div class="selectd">
              <p class="selected-p"></p>
              <p class="selected-p-one"></p>
            </div> -->
            <div class="selectd">
              <p class="selected-p">
                <span v-for="(type, index) in selectedConferenceTypes" :key="index" class="filter-tag">
                  {{ formatTagDisplay(type) }} <span class="close-icon" @click="removeConferenceType(index)">×</span>
                </span>
                <span v-for="(category, index) in selectedCategories" :key="index" class="filter-tag">
                  {{ formatTagDisplay(category) }} <span class="close-icon" @click="removeCategory(index)">×</span>
                </span>

                <span v-for="(tag, index) in selectedTags" :key="index" class="filter-tag">
                  {{ formatTagDisplay(tag) }} <span class="close-icon" @click="removeTag(index)">×</span>
                </span>

                <span v-for="(room, index) in selectedRooms" :key="index" class="filter-tag">
                  {{ formatTagDisplay(room) }} <span class="close-icon" @click="removeRoom(index)">×</span>
                </span>

                <span v-for="(format, index) in selectedSessionFormats" :key="index" class="filter-tag">
                  {{ formatTagDisplay(format) }} <span class="close-icon" @click="removeSessionFormat(index)">×</span>
                </span>
              </p>
            </div>
          </div>
          <!-- clear filter ends -->
          <div class="multi-filter-main-wrapper">
            <div class="multi-filter-wrapper">
              <div class="multi-filter-row">
                <div class="agenda-search-filter">
                  <svg style="position: absolute;
                  left: 20px;
                  top: 22px;" width="20" height="20" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h16v16H0z"/><path d="m15.708 13.587-3.675-3.675a6.5 6.5 0 1 0-2.121 2.121l3.675 3.675a1.003 1.003 0 0 0 1.414 0l.707-.707a1.003 1.003 0 0 0 0-1.414M3.318 9.682C2.468 8.832 2 7.702 2 6.5s.468-2.332 1.318-3.182S5.298 2 6.5 2s2.332.468 3.182 1.318S11 5.298 11 6.5s-.468 2.332-1.318 3.182S7.702 11 6.5 11s-2.332-.468-3.182-1.318"/></svg>
                  <input type="text" v-model="searchQuery" id="searchBar" />
                </div>

                <div class="multi-filter-col multi-filter-col-large primary-filter">
                  <div class="multi-filter-body" ref="primaryFilter">
                    <div class="custom-filter-head" @click="togglePrimaryfilter">
                      <span>Conference Type</span>
                      <svg :class="{ rotate: isPrimaryfilterExpanded }" fill="#000000" viewBox="0 0 32 32"
                        version="1.1">
                        <path
                          d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z">
                        </path>
                      </svg>
                    </div>

                    <div class="custom-filter-contant" :class="{ expanded: isPrimaryfilterExpanded }">
                      <ul>
                        <li v-for="(conferenceType, index) in allConferenceTypes" v-bind:key="index">
                          <label class="multi-filter-selector">{{ conferenceType.type }} 
                            <input type="checkbox" name="access-pass" class="multi-filter-checkbox"
                              :data-access-pass="conferenceType.value" v-bind:value="conferenceType.value" v-model="selectedConferenceTypes"/>
                            <span class="multi-filter-checkmark"></span>
                          </label>
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
                <div :class="[
          'multi-filter-col',
          'multi-filter-col-large',
          'secondary-filter',
          { disabled: !hasCategories }
        ]">
                  <div class="multi-filter-body" ref="secondaryFilter">
                    <div class="custom-filter-head" @click="hasCategories ? toggleSecondaryfilter() : null">
                      <span>Conference Program</span>
                      <svg :class="{ rotate: isSecondaryfilterExpanded }" fill="#000000" viewBox="0 0 32 32"
                        version="1.1">
                        <path
                          d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z">
                        </path>
                      </svg>
                    </div>
                    <div class="custom-filter-contant" :class="{
          expanded:
            isSecondaryfilterExpanded,
        }">
                      <ul>
                        <!-- <li v-for="(category, index) in allCategory" v-bind:key="index">
                          <label class="multi-filter-selector">{{ category.category }}
                            <input type="checkbox" class="multi-filter-checkbox" :data-access-pass="category.type"
                              name="conference-stream" v-bind:value="category.value" v-model="selectedCategories"/>
                            <span class="multi-filter-checkmark"></span>
                          </label>
                        </li> -->
                        <li v-for="(category, index) in allCategory" v-bind:key="index">
                          <label class="multi-filter-selector">{{ category.category }}
                            <input type="checkbox" class="multi-filter-checkbox" :data-access-pass="category.type"
                              v-bind:value="category.value" v-model="selectedCategories"/>
                            <span class="multi-filter-checkmark"></span>
                          </label>
                        </li>
                        
                      </ul>
                    </div>
                  </div>
                </div>
                <div :class="[
          'multi-filter-col',
          'secondary-filter',
        ]">
                  <div class="multi-filter-body" ref="tertiaryFilter">
                    <div class="custom-filter-head" @click="hasTags ? toggleTertiaryfilter() : null">
                      <span>Themes</span>
                      <svg :class="{ rotate: isTertiaryfilterExpanded }" fill="#000000" viewBox="0 0 32 32"
                        version="1.1">
                        <path
                          d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z">
                        </path>
                      </svg>
                    </div>
                    <div class="custom-filter-contant" :class="{
          expanded:
            isTertiaryfilterExpanded
        }">
                      <ul>
                        <li v-for="(tag, index) in allTags" v-bind:key="index">
                          <label class="multi-filter-selector">{{ tag.tags }}
                            <input type="checkbox" class="multi-filter-checkbox" name="location"
                              v-bind:value="tag.value" v-model="selectedTags"/>
                            <span class="multi-filter-checkmark"></span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="multi-filter-col secondary-filter" :class="{ disabled: !hasRooms }">
                  <div class="multi-filter-body" ref="roomFilter">
                    <div class="custom-filter-head" @click="hasRooms ? toggleRoomFilter() : null">
                      <span>Location</span>
                      <svg :class="{ rotate: isRoomFilterExpanded }" fill="#000000" viewBox="0 0 32 32" version="1.1">
                        <path d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z"></path>
                      </svg>
                    </div>
                    <div class="custom-filter-contant" :class="{ expanded: isRoomFilterExpanded }">
                      <ul>
                        <li v-for="(room, index) in allRooms" :key="index">
                          <label class="multi-filter-selector">
                            {{ room.room }}
                            <input type="checkbox" class="multi-filter-checkbox" v-model="selectedRooms"  v-bind:value="room.value">
                            <span class="multi-filter-checkmark"></span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="multi-filter-col secondary-filter" :class="{ disabled: !hasSessionFormats }">
                  <div class="multi-filter-body" ref="sessionFormatFilter">
                    <div class="custom-filter-head" @click="hasSessionFormats ? toggleSessionFormatFilter() : null">
                      <span>Session Format</span>
                      <svg :class="{ rotate: isSessionFormatExpanded }" fill="#000000" viewBox="0 0 32 32" version="1.1">
                        <path d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z"></path>
                      </svg>
                    </div>
                    <div class="custom-filter-contant" :class="{ expanded: isSessionFormatExpanded }">
                      <ul>
                        <li v-for="(format, index) in allSessionFormats" :key="index">
                          <label class="multi-filter-selector">{{ format.sessionFormat }}
                            <input type="checkbox" class="multi-filter-checkbox"
                              @change="updateSelectedSessionFormats(format.value)" :checked="selectedSessionFormats.includes(format.value)">
                            <span class="multi-filter-checkmark"></span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>                
                <div class="multi-filter-col d-none-layout-2">
                  <div class="multi-filter-body" ref="layoutFilter">
                    <div class="custom-filter-head" @click="toggleLayoutfilter">
                      <span>{{ layoutFilterText }}</span>
                      <svg :class="{ rotate: isLayoutfilterExpanded }" fill="#000000" viewBox="0 0 32 32" version="1.1">
                        <path
                          d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z">
                        </path>
                      </svg>
                    </div>
                    <div class="custom-filter-contant" :class="{ expanded: isLayoutfilterExpanded }">
                      <ul>
                        <li class="d-sm-none">
                          <label class="multi-filter-selector">Day view
                            <input @change="navigateOnCheck($event, firstAvailableDay.startDate)" type="checkbox" class="view-change-check-main" v-model="isDayViewActive" />
                            <span class="multi-filter-checkmark"></span>
                          </label>
                        </li>
                        <li v-for="(day,index) in days" v-bind:key="index">
                          <label class="multi-filter-selector" v-if="checkAnyAgendas(day.startDate)">{{ day.dayname }}
                            {{ getDayOfMonth(day.startDate) }}
                            <input type="checkbox" class="view-change-check"
                              @change="navigateOnCheck($event, day.startDate)" />
                            <span class="multi-filter-checkmark"></span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="multi-filter-col secondary-filter">
                  <div class="multi-filter-body">
                    <button @click="resetFilters">Reset</button>
                  </div>
                </div>
              </div>
            </div>
            <!-- clear filter starts -->
            <div class="multi-clear-wrapper">
              <!-- <div class="clear-all-multy">
              clear all
          </div> -->
              <!-- <div class="selectd">
                <p class="selected-p"></p>
                <p class="selected-p-one"></p>
              </div> -->
              <div class="selectd">
                <!-- Display selected conference types -->
                <p class="selected-p">
                  <span v-for="(type, index) in selectedConferenceTypes" :key="index" class="filter-tag">
                    {{ formatTagDisplay(type) }} <span class="close-icon" @click="removeConferenceType(index)">×</span>
                  </span>
                </p>
                <!-- Display selected categories -->
                <p class="selected-p">
                  <span v-for="(category, index) in selectedCategories" :key="index" class="filter-tag">
                    {{ formatTagDisplay(category) }} <span class="close-icon" @click="removeCategory(index)">×</span>
                  </span>

                  <span v-for="(tag, index) in selectedTags" :key="index" class="filter-tag">
                    {{ formatTagDisplay(tag) }} <span class="close-icon" @click="removeTag(index)">×</span>
                  </span>

                  <span v-for="(room, index) in selectedRooms" :key="index" class="filter-tag">
                    {{ formatTagDisplay(room) }} <span class="close-icon" @click="removeRoom(index)">×</span>
                  </span>

                  <span v-for="(format, index) in selectedSessionFormats" :key="index" class="filter-tag">
                    {{ formatTagDisplay(format) }} <span class="close-icon" @click="removeSessionFormat(index)">×</span>
                  </span>
                </p>
              </div>
            </div>

            <!-- clear filter ends -->
            <div class="agenda-accordion-wrapper">
              <div class="no-data-div">
                <h4>No results found, please adjust the filters</h4> 
              </div>
              <div class="loader-wrapper" v-if="loader">
                <div class="loader" ></div>
              </div>
             
              <h3 class="agenda-date-time" v-if="isDayViewActive">  {{ formatDate(groupAgendaByTime(agendaList)[0][0].startDate) }}</h3>
              <div class="multy-agenda-tab-content active" v-for="(agendas,index) in groupAgendaByTime(agendaList)"
                v-bind:key="index">

                <div class="agenda-masonry-card">
                  <template v-for="(agenda, selected) in agendas">
                  <div class="agenda-masonry strategic" v-if="agenda.title != 'Break'" v-bind:key="selected">
                    <p>
                      {{ formatTime(agenda.startTime) }} -
                      {{ formatTime(agenda.endTime) }}
                    </p>
                    <span class="tag" v-if="agenda.type && agenda.type != 'Strategic Conference'">{{
                      agenda.type
                    }}</span>
                   
                    <span class="tag" v-if="getCategoryLabel('category_1718137021077',agenda.session_categories)" :style="{
                      backgroundColor: getBackgroundColor(agenda.type,getCategoryLabel('category_1718137021077',agenda.session_categories)),
                    }">
                      {{ getCategoryLabel('category_1718137021077',agenda.session_categories) }}
                    </span>
                                <!-- <span class="tag" v-if="agenda.category" :style="{
                                  backgroundColor: agenda.type == 'Strategic Conference' ? getCategoryColor(agenda.category) : getCategoryColorTC(agenda.category),
                    }">
                                  {{ agenda.category }}
                                </span> -->
                                <span class="tag" v-if="agenda.room && agenda.type == 'Strategic Conference'" :style="{
                                  backgroundColor: getBackgroundColor(agenda.type,agenda.room)
                                }">{{
                                  agenda.room
                                }}</span>
                    <h3 class="agenda-popup-click search-element"
                      @click="getagendaDetailsById(agenda.publishedSessionId)" v-if="agenda.title">
                      {{ agenda.title }}
                    </h3>
                    
                    
                    <p v-if="agenda.description" v-html="getFirstParagraph(agenda.description)"></p>
                    <!-- <p class="agenda-multi-time">
                      <svg viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                          stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 6V12" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M16.24 16.24L12 12" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>{{ dayname }} {{ startDateFormatted }}
                      {{ formatTime(startTime) }} - {{ formatTime(endTime) }}
                    </p> -->
                    <!-- <span class="tag" v-if="agenda.tags">{{agenda.tags}}</span> -->
                    <div class="agenda-multi-speaker" v-if="agenda.user && agenda.user.length > 0">
                                        <div class="agenda-multi-speaker-col" v-for="user in agenda.user" :key="user.Id">
                                          <div class="agenda-multi-speaker-wrapper">
                                            <div class="agenda-multi-speaker-img">
                                              <a :href="`https://www.gastechevent.com/speakerdetails?userId=${user.apiId}#top`">
                                              <img v-if="user.avatar == null ||
                                  user.avatar ==
                                  'https://www.dmgeventsconferences.com/'
                                  " src="https://www.futureenergyasia.com/media/7674/speaker-default.jpg" alt="" width="80"
                                                height="80" />
                                              <img v-else :srcset="user.avatar" />
                                            </a>
                                            </div>
                                            <div class="agenda-multi-speaker-content">
                                              <span v-if="user.isModerator">Moderator</span>
                                              <h6 v-if="user.name">{{ user.name }}</h6>
                                              <span v-if="user.jobTitle">{{
                                  user.jobTitle
                                }}</span>
                                              <span v-if="user.role">{{ user.role }}</span>
                                              <span v-if="user.company"><strong>{{ user.company }}</strong>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                  </div>
                </template>
                </div>
              </div>
              <div class="agenda-accordion-row">
                <template v-for="day in days">
                  <div class="agenda-accordion-col" :id="day.startDate" v-bind:key="day.id"
                    v-if="checkAnyAgendas(day.startDate)">
                    <div class="agenda-accordion-click">
                      <label class="multi-filter-selector">{{ day.dayname }} {{ getDayOfMonth(day.startDate) }}
                        {{ getMonthName(day.startDate) }}
                        <input type="checkbox" class="view-change-check" />
                        <span class="multi-filter-checkmark"></span>
                      </label>
                      <!-- <h4></h4> -->
                    </div>
                    <div class="agenda-masonry-wrap">
                      <template v-for="agenda in getAgendaByDay(
                        agendaAllList,
                        day.startDate
                      )[0]">
                      <div class="agenda-masonry strategic" v-if="agenda.title != 'Break'"  v-bind:key="agenda.Id">
                        <p>
                          {{ formatTime(agenda.startTime) }} -
                          {{ formatTime(agenda.endTime) }}
                        </p>
                        <h3 class="agenda-popup-click" @click="
          getagendaDetailsById(agenda.publishedSessionId)
          ">
                          {{ agenda.title }}
                        </h3>
                        <span class="tag" v-if="agenda.type">{{
          agenda.type
        }}</span>
        <span class="tag" v-if="getCategoryLabel('category_1718137021077',agenda.session_categories)" :style="{
          backgroundColor: getBackgroundColor(agenda.type,getCategoryLabel('category_1718137021077',agenda.session_categories)),
        }">
          {{ getCategoryLabel('category_1718137021077',agenda.session_categories) }}
        </span>
                        <!-- <span class="tag" v-if="agenda.category">{{agenda.category}}</span> -->
                        <!-- <span
                      class="tag" v-if="agenda.tags">{{agenda.tags}}</span>  -->
                      </div>
                    </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="multi-agenda-popup-wraper">
      <div class="multi-agenda-popup">
        <div class="container-row">
          <div class="popup-welcome-note">
            <div class="agenda-back-btn" @click="closeAgendaPopup()">
              <a href="#">
                X
              </a>
            </div>
            <div class="popup-welcome-wrap">
              <div class="popup-welcome-right">
                <div class="popup-welcome-content">
                  <h3>{{ heading }}</h3>
                  <span style="margin-bottom:10px"><svg viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                        stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>

                      <path d="M12 6V12" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round">
                      </path>

                      <path d="M16.24 16.24L12 12" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                    </svg>{{ dayname }} {{ startDateFormatted.replace(',','') }}
                    {{ formatTime(startTime) }} -
                    {{ formatTime(endTime) }}</span>
                  <span style="margin-bottom:10px" class="tag" v-if="type">{{
          type
        }}</span>
        <span class="tag" v-if="getCategoryLabelPopup('category_1718137021077',session_categories)" :style="{
          backgroundColor: getBackgroundColor(agendatype,getCategoryLabelPopup('category_1718137021077',session_categories)),
        }">
          {{ getCategoryLabelPopup('category_1718137021077',session_categories) }}
        </span>
                  <!-- <span class="tag" v-if="category" :style="{
                    backgroundColor: type == 'Strategic Conference' ? getCategoryColor(category) : getCategoryColorTC(category),
          marginBottom: '10px',
        }">
                    {{ category }}
                  </span> -->

                  <!-- <span
              class="tag color-11" v-if="tags">{{tags}}</span>  -->
                  <span class="tag" :style="{
                    backgroundColor: getBackgroundColor(agendatype,room),
                    marginBottom: '10px',
                  }" v-if="room">{{ room }}</span>
                  
                  <p v-if="description" v-html="description"></p>

                  <template v-if="slotsList.length > 0">
                    <div v-for="slot in slotsList" v-bind:key="slot.Id">
                      <h3 :key="slot.Id">{{ slot.title }}</h3>
                      <p>
                        {{ formatTime(slot.startTime) }} -
                        {{ formatTime(slot.endTime) }}
                      </p>
                      <div class="slot-description" v-for="abstractData in slot.abstractData"
                        v-bind:key="abstractData.Id">
                        <p>{{ abstractData.value }}</p>
                      </div>
                      <!-- <div v-if="slot.slotUsers && slot.slotUsers.length > 0">
                      <h6 v-if="speakers(slot.slotUsers).length > 1">
                        Speakers
                      </h6>
                      <h6 v-else>Speaker</h6>
                      <div class="agenda-multi-speaker">
                        <div class="agenda-multi-speaker-col" v-for="slotUser in slot.slotUsers"
                          v-bind:key="slotUser.Id">

                          <div class="agenda-multi-speaker-wrapper">
                            <div class="agenda-multi-speaker-img">
                              <img v-if="slotUser.avatar == null ||
              user.avatar ==
              'https://www.dmgeventsconferences.com/'
              " src="https://www.futureenergyasia.com/media/7674/speaker-default.jpg" alt=""
                                width="80" height="80" />
                              <img v-else :srcset="slotUser.avatar" />
                            </div>
                            <div class="agenda-multi-speaker-content">
                              <span v-if="slotUser.isModerator">Moderator</span>
                              <h6 v-if="slotUser.name">
                                {{ slotUser.name }}
                              </h6>
                              <span v-if="slotUser.jobTitle">{{
              slotUser.jobTitle
            }}</span>
                              <span v-if="slotUser.role">{{
              slotUser.role
            }}</span>
                              <span v-if="slotUser.company"><strong>{{ slotUser.company }}</strong>
                              </span>
                            </div>

                        </div>

                      </div>
                    </div> -->
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="popup-welcome-wrap popup-welcome-wrap-change" v-if="userList && userList.length > 0">
            <div class="popup-welcome-right">
              <div class="popup-welcome-content">
                <h3>Speakers</h3>
                <div class="agenda-multi-speaker" v-if="userList && userList.length > 0">
                  <div class="agenda-multi-speaker-col" v-for="User in userList" :key="User.Id">
                    <div class="agenda-multi-speaker-wrapper">
                      <a href=""></a>
                      <div class="agenda-multi-speaker-img">
                        <a :href="`https://www.gastechevent.com/speakerdetails?userId=${User.apiId}#top`">
                        <img v-if="!User.avatar ||
              User.avatar ===
              'https://www.dmgeventsconferences.com/'
              " src="https://www.futureenergyasia.com/media/7674/speaker-default.jpg" alt="" width="80"
                          height="80" />
                        <img v-else :srcset="User.avatar" />
                        </a>
                      </div>
                      <div class="agenda-multi-speaker-content">
                        <span v-if="User.isModerator">Moderator</span>
                        <h6 v-if="User.name">{{ User.name }}</h6>
                        <span v-if="User.jobTitle">{{ User.jobTitle }}</span>
                        <span v-if="User.role">{{ User.role }}</span>
                        <span v-if="User.company"><strong>{{ User.company }}</strong>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
   
  </div>
  
</template>

<script>
import $ from "jquery";
import axios from "axios";
import url from "./../../config/url";
export default {
  name: "ExhibitorList",
  data() {
    return {
      isSessionFormatExpanded: false,
      selectedSessionFormats: [],
      searchQuery: '',
      isDayViewActive: false,
      isPrimaryfilterExpanded: false,
      isSecondaryfilterExpanded: false,
      isLayoutfilterExpanded: false,
      isTertiaryfilterExpanded: false,
      selectedConferenceTypes: [],
      selectedTags: [],
      selectedCategories: [],
      selectedRooms: [],
      isRoomFilterExpanded: false,
      days: "",
      categoryList: "", // debugger
      activeDay: null,
      selectedCategory: "all",
      type: "",
      layoutFilterText: 'View',
      user: [
        {
          Id: 1,
          name: "Speaker 1",
          jobTitle: "Developer",
          role: "Speaker",
          company: "Company A",
          isModerator: false,
        },
        {
          Id: 2,
          name: "Speaker 2",
          jobTitle: "Designer",
          role: "Speaker",
          company: "Company B",
          isModerator: true,
        },
        {
          Id: 3,
          name: "Speaker 3",
          jobTitle: "Developer",
          role: "Moderator",
          company: "Company A",
          isModerator: true,
        },
        {
          Id: 4,
          name: "Speaker 4",
          jobTitle: "Designer",
          role: "Speaker",
          company: "Company B",
          isModerator: false,
        },
        {
          Id: 5,
          name: "Speaker 5",
          jobTitle: "Manager",
          role: "Speaker",
          company: "Company C",
          isModerator: false,
        },
      ],
    };
  },
  watch: {
    //Watchers to apply filters whenever filter criteria change
    selectedConferenceTypes() {
      if (this.selectedConferenceTypes == null || this.selectedConferenceTypes.length == 0) {
        this.selectedTags = [],
          this.selectedCategories = []
      }
     
      this.applyFilters();

    },
    searchQuery() {
      this.applyFilters();
    },
    selectedCategories() {
      
      this.applyFilters();
    },
    selectedSessionFormats(){
      this.applyFilters();
    },
    selectedTags() {
      this.applyFilters();
    },
    selectedRooms(){
      this.applyFilters();
    }
  },
  computed: {
    filteredDays() {
    return this.days.filter(day => this.checkAnyAgendas(day.startDate));
  },
  // Returns the first available day or null if none
  firstAvailableDay() {
    return this.filteredDays.length > 0 ? this.filteredDays[0] : null;
  },
    agendaList: function () {
      //debugger
      return this.$store.state.agendalistInitial.exhibitors;
    },
    filters: function(){
      return this.$store.state.agendalistInitial.agendaFilters;
    },
    agendaAllList: function () {
      //debugger
      return this.$store.state.agendalistInitial.exhibitorCollection;
    },
    agendaForFilters: function () {
      //debugger
      return this.$store.state.agendalistInitial.exhibitorForFilters;
    },
    /*for popup agenda data*/
    companyName: function () {
      return this.$store.state.agendalistInitial.title;
    },
    category: function () {
      return this.$store.state.agendalistInitial.category;
    },
    tags: function () {
      return this.$store.state.agendalistInitial.tags;
    },
    session_categories: function () {
      return this.$store.state.agendalistInitial.session_categories;
    },
    description: function () {
      return this.$store.state.agendalistInitial.description;
    },
    room: function () {
      return this.$store.state.agendalistInitial.room;
    },
    agendatype: function () {
      return this.$store.state.agendalistInitial.type;
    },
    heading: function () {
      //debugger
      return this.$store.state.agendalistInitial.heading;
    },
    hosted: function () {
      return this.$store.state.agendalistInitial.hosted;
    },
    assets: function () {
      return this.$store.state.agendalistInitial.assets;
    },
    startDate: function () {
      return this.$store.state.agendalistInitial.startDate;
    },
    startTime: function () {
      return this.$store.state.agendalistInitial.startTime;
    },
    endTime: function () {
      return this.$store.state.agendalistInitial.endTime;
    },
    publishedSessionId: function () {
      //debugger
      return this.$store.state.agendalistInitial.publishedSessionId;
    },
    userList: function () {
      return this.$store.state.agendalistInitial.user;
    },
    slotsList: function () {
      //debugger
      return this.$store.state.agendalistInitial.slots;
    },
    dayname: function () {
      return this.$store.state.agendalistInitial.dayname;
    },
    loader: function () {
      return this.$store.state.agendalistInitial.loader;
    },
    startDateFormatted: function () {
      // debugger
      return this.$store.state.agendalistInitial.startDateFormatted;
    },
    /*for popup agenda data - end*/
    currentHashId() {
      // debugger
      return this.activeDay.startDate;
    },
    hasSessionFormats() {
    return this.allSessionFormats.length > 0;
  },
  hasConferenceTypes() {
    return this.allConferenceTypes.length > 0;
  },
  hasCategories() {
    return this.allCategory.length > 0;
  },
  hasTags() {
    return this.allTags.length > 0;
  },
  hasRooms() {
    return this.allRooms.length > 0;
  },
    isStrategicConferenceSelected() {
    return this.selectedConferenceTypes.includes('Strategic-Conference');
  },

    roles() {
      //debugger
      const uniqueRoles = new Set();
      this.agenda.user.forEach((user) => uniqueRoles.add(user.role));
      return Array.from(uniqueRoles);
    },

  allSessionFormats: function () {
  const sessionFormatFilter = this.filters && this.filters.find(f => f.categoryLabel === 'Session Format');
  return sessionFormatFilter ? sessionFormatFilter.categoryOptions.map(option => ({
    sessionFormat: option.option_label,
    value: option.option_id
  })) : [];
},
//   allRooms: function () {
//   if (!this.agendaForFilters /*|| this.selectedConferenceTypes.length === 0 || this.selectedCategories.length === 0 || this.selectedTags.length === 0*/) {
//      return []; // If any filter is not selected, return an empty array
//   }
//   const roomsSet = new Set();
//   this.agendaForFilters.forEach(agenda => {
//    // Skip agendas that don't have tags
//    if (!agenda.tags) return;

//    // Split and normalize the agenda's tags
//     const agendaTags = agenda.session_categories && agenda.session_categories.find(f => f.id === 'category_1718137161856'); //id of themes
//    let tagsMatch = false; // Assume no tags match initially

//     for (let selectedTag of this.selectedTags) {
//         if (agendaTags && agendaTags.options.some(opt => opt.id == selectedTag)) {
//            tagsMatch = true; // If any selected tag is found, set to true and break
//             break;
//         }
//     }

//     // Only add the room to the set if any tag matches
//     if (tagsMatch) {
//       const transformedValue = agenda.room.replace(/\s+/g, '-');
//      roomsSet.add(JSON.stringify({ room: agenda.room, value: transformedValue }));
//     }
//   });
//  // Convert the Set back to an array
//   return Array.from(roomsSet).map(item => JSON.parse(item));
// },

allRooms: function () {
  if (!this.agendaForFilters /*|| this.selectedConferenceTypes.length === 0 || this.selectedCategories.length === 0 || this.selectedTags.length === 0*/) {
     return []; // If any filter is not selected, return an empty array
  }
  const roomsSet = new Set();
  this.agendaForFilters.forEach(agenda => {
   // Skip agendas that don't have tags
   if (!agenda.tags) return;

   // Split and normalize the agenda's tags
    const agendaTags = agenda.session_categories && agenda.session_categories.find(f => f.id === 'category_1718137161856'); //id of themes
   let tagsMatch = false; // Assume no tags match initially

    for (let selectedTag of this.selectedTags) {
        if (agendaTags && agendaTags.options.some(opt => opt.id == selectedTag)) {
           tagsMatch = true; // If any selected tag is found, set to true and break
            break;
        }
    }

    // Only add the room to the set if any tag matches
    if (tagsMatch) {
      const transformedValue = agenda.room.replace(/\s+/g, '-');
     roomsSet.add(JSON.stringify({ room: agenda.room, value: transformedValue }));
    }
  });
 // Convert the Set back to an array
  return Array.from(roomsSet).map(item => JSON.parse(item));
},

    allCategory: function () {
  // Assuming the filters data is stored in a state or a data property
  const conferenceProgramFilter = this.filters && this.filters.find(f => f.categoryLabel === 'Conference Program');
  return conferenceProgramFilter ? conferenceProgramFilter.categoryOptions.map(option => ({
    category: option.option_label,
    value: option.option_id
  })) : [];
},
    allConferenceTypes: function () {
      if (!this.agendaForFilters) {
        return []; // Return an empty array if agendaForFilters is not available
      }
      const ConferenceTypesSet = new Set();
      this.agendaForFilters.forEach(agenda => {
        if (agenda.type !== null && agenda.type !== undefined) {
          const transformedConferenceTypes = agenda.type.replace(/\s+/g, '-');
          ConferenceTypesSet.add(JSON.stringify({ type: agenda.type, value: transformedConferenceTypes }));
        }
      });
      // Convert the Set back to an array
      return Array.from(ConferenceTypesSet).map(item => JSON.parse(item));
    },
    allTags: function () {
  const themesFilter = this.filters && this.filters.find(f => f.categoryLabel === 'Themes');
  return themesFilter ? themesFilter.categoryOptions.map(option => ({
    tags: option.option_label,
    value: option.option_id
  })) : [];
}
  },
  mounted() {
    this.loader = true;
    this.checkAgendaPopupQuery();
    this.getFilters();
    const pathname = window.location.pathname;
    if (pathname.includes("strategic")) {
      this.type = "Strategic";
      //this.type = "Strategic Summit";
    } else if (pathname.includes("technical")) {
      this.type = "Technical Conference";
    } else {
      this.type = "";
    }

    //remove this later
    //this.selectedConferenceTypes.push('Strategic-Conference');
    this.getAllCategoryList();
    this.getAllDayList(this.type);
    this.getAllAgendaList(this.type);
    document.addEventListener('click', this.handleOutsideClick);
    this.checkScreenWidth();
    window.addEventListener('resize', this.checkScreenWidth);
    this.checkForConferenceTypeInQuery();
    this.loader = false;
    
  },
  beforeUpdate(){
    const queryParams = new URLSearchParams(window.location.search);
    let conferenceType = queryParams.get('conferencetype');
    let conferenceProgram = queryParams.get('conferenceprogram');
    if(conferenceType || conferenceProgram){
      this.applyFilters()
    }
    
  },
  beforeDestroy() {
  // Remove the listener when the component is about to be destroyed
  document.removeEventListener('click', this.handleOutsideClick);
},
  methods: {
   
    resetFilters() {
    this.selectedConferenceTypes= [];
    this.selectedTags = [];
    this.selectedCategories = [];
    this.selectedRooms = [];
    this.searchQuery = '';
    this.isDayViewActive = false;
    this.isPrimaryfilterExpanded = false;
    this.isSecondaryfilterExpanded = false;
    this.isTertiaryfilterExpanded = false;
    this.isRoomFilterExpanded = false;
    this.isSessionFormatExpanded = false;
    this.selectedSessionFormats = [];
    // Optionally, reset any other properties or state variables if needed

    // Reapply filters to show all items
    this.applyFilters();
  },

  checkAgendaPopupQuery(){
    const queryParams = new URLSearchParams(window.location.search);
    let conferenceType = queryParams.get('agenda');
    if(conferenceType){
      this.getagendaDetailsById(conferenceType);
    }
  },
  async checkForConferenceTypeInQuery() {
    const queryParams = new URLSearchParams(window.location.search);
    let conferenceType = queryParams.get('conferencetype');
    let conferenceProgram = queryParams.get('conferenceprogram');
    
    if (conferenceProgram) {

      // conferenceProgram = this.capitalizeWords(conferenceProgram);
      // conferenceProgram = conferenceProgram.replace(/-/g, ' ');
      // alert(conferenceProgram)
     
      //let catId= this.getCategoryIdByName(conferenceProgram)
      if (!this.selectedCategories.includes(conferenceProgram)) {
        this.selectedCategories.push(conferenceProgram);
      }
    }

    if (conferenceType) {
      conferenceType = this.capitalizeWords(conferenceType); // Apply the formatting function
      if (!this.selectedConferenceTypes.includes(conferenceType)) {
        this.selectedConferenceTypes.push(conferenceType);
      }
    }
  },
  capitalizeWords(inputString) {
    return inputString
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('-');
  },
  // getCategoryIdByName(categoryName) {
  //   debugger
  //   console.log(categoryName)
  //   console.log("cat",this.categoryList)
  //    const categoryProgram = this.categoryList.find(category => category.categoryLabel === "Conference Program");
  //    const category = categoryProgram.categoryOptions.find(category => category.option_label.toUpperCase === categoryName.toUpperCase);
  //   return category ? category.option_id : '';
  // },
  getCategoryLabel(categoryId,session_category) {
      if (!session_category || !Array.isArray(session_category)) {
        return null;
      }
      const category = session_category && session_category.find(cat => cat.id === categoryId);
      return category ? category.options[0].label : null;
    },

    getCategoryLabelPopup(categoryId, session_category) {
      if (!session_category || !Array.isArray(session_category)) {
        return null;
      }
      const category = session_category && session_category.find(cat => cat.id === categoryId);
      return category && category.Options && category.Options.length > 0 ? category.Options[0].Label : null;
  },
    getFirstParagraph(htmlContent) {
    // Create a new DOM parser instance
    const parser = new DOMParser();
    // Parse the HTML content into a document
    const doc = parser.parseFromString(htmlContent, 'text/html');
    // Get the first <p> element
    const firstParagraph = doc.querySelector('p');
    // Return the innerHTML of the first paragraph, or an empty string if no paragraph is found
    return firstParagraph ? firstParagraph.innerHTML : '';
  },
    handleOutsideClick(e) {
    // Define a helper function to check if the clicked element is outside
    function isClickedOutside(element) {
      return !element.contains(e.target);
    }

    // Retrieve your filter elements by their refs
    const primaryFilter = this.$refs.primaryFilter;
    const secondaryFilter = this.$refs.secondaryFilter;
    const tertiaryFilter = this.$refs.tertiaryFilter;
    const roomFilter = this.$refs.roomFilter;
    const layoutFilter = this.$refs.layoutFilter;
    const sessionFormatFilter = this.$refs.sessionFormatFilter;

    // Check if the click was outside any of the filters
    if (primaryFilter && isClickedOutside(primaryFilter)) {
      this.isPrimaryfilterExpanded = false;
    }
    if (secondaryFilter && isClickedOutside(secondaryFilter)) {
      this.isSecondaryfilterExpanded = false;
    }
    if (tertiaryFilter && isClickedOutside(tertiaryFilter)) {
      this.isTertiaryfilterExpanded = false;
    }
    if (roomFilter && isClickedOutside(roomFilter)) {
      this.isRoomFilterExpanded = false;
    }
    if (layoutFilter && isClickedOutside(layoutFilter)) {  // Add this condition for layout filter
    this.isLayoutfilterExpanded = false;
  }
  if (sessionFormatFilter && isClickedOutside(sessionFormatFilter)) {  // Add this condition for layout filter
    this.isSessionFormatExpanded = false;
  }
  },
    toggleRoomFilter() {
    this.isRoomFilterExpanded = !this.isRoomFilterExpanded;
  },
  checkScreenWidth() {
      this.isLayoutfilterExpanded = window.innerWidth < 600;
      this.layoutFilterText = this.isLayoutfilterExpanded ? 'Select day' : 'View';
    },
    getCategoryColor(category) {
      const colors = {
        'Climatetech Strategic': '#9B2A79',
        'Strategy & Leadership': '#273480',
        'Hydrogen Strategic': '#0086a6',
        'Strategic Leadership': '#273480',
        'Climatetech & AI Strategic' : '#9B2A79',
        'Climatetech & AI Theater' : '#2b2159',
        'Hydrogen Theater' : '#00474f',
        'Plenary' : '#0bbbef',
        'Plenary II' : '#0bbbef',
        'Energy Talks': '#22315f'
      };
      return colors[category] || '#0bbbef'; // 'defaultColor' is a fallback color
    },
    getCategoryColorTC(category) {
      const colors = {
        'Shipping & Marine': '#54c3bd',
        'Shipping & Marine Theater': '#38516b',
        'EPC & Gas Processing': ' #f26c4f',
        'EPC & Gas Processing Theater': '#0e2342',
        'Climatetech & AI' : '#9B2A79',
        'Climatetech & AI Theater' : '#2b2159',
        'Hydrogen' : '#0086a6',
        'Hydrogen Theater' : '#00474f',
        'Commercial' : '#0bbbef',
        'Commercial Theater': '#273480'
      };
      return colors[category] || '#0bbbef'; // 'defaultColor' is a fallback color
    },

    getCategoryColorFP(category) {
      const colors = {
        'Feature Programs': '#0bbbef',
        'Future Leaders': '#f6a24a',
        'Procurement Meeting Place': '#22315f',
        'Procurement Meeting Place Theater': '#273480',
        'Diversity, Equity & Inclusion in Energy' : '#6f5ca4'
      };
      return colors[category] || '#0bbbef'; // 'defaultColor' is a fallback color
    },
    
    getBackgroundColor(type, category) {
      if (type === 'Strategic Conference') {
        return this.getCategoryColor(category);
      } else if (type === 'Feature Programs') {
        return this.getCategoryColorFP(category);
      } else {
        return this.getCategoryColorTC(category);
      }
    },
    checkAnyAgendas(date) {
      let agendas = this.getAgendaByDay(this.agendaAllList, date);
      return agendas && agendas.length > 0;
    },
    
    applyFilters() {
if(this.agendaForFilters){
  let result = this.agendaForFilters;
  //Check if no filters are applied
  if (!this.searchQuery && this.selectedConferenceTypes.length === 0 &&
      this.selectedCategories.length === 0 && this.selectedTags.length === 0 &&
      this.selectedSessionFormats.length === 0) {
    this.$store.dispatch("setFilteredagenda", result);
    return;
  }

//   result = result.filter(agenda => {
//     return this.selectedConferenceTypes.length === 0 || this.selectedConferenceTypes.includes(agenda.type ? agenda.type.replace(/\s+/g, '-') : "");
// });

// result = result.filter(agenda => {
//     return  this.selectedSessionFormats.length === 0 || agenda.session_categories?.some(cat =>
//        cat.options?.some(opt => this.selectedSessionFormats.includes(opt.id))
//     )
// });

// result = result.filter(agenda => {
//     return  this.selectedCategories.length === 0 || agenda.session_categories?.some(cat =>
//     cat.options?.some(opt => this.selectedCategories.includes(opt.id))
//      )
// });

// result = result.filter(agenda => {
//     return  this.selectedTags.length === 0 || agenda.session_categories?.some(cat =>
//     cat.options?.some(opt => this.selectedTags.includes(opt.id))
//      )
// });
result = result.filter(agenda => {
    // Check conference types
    const isValidType = this.selectedConferenceTypes.length === 0 ||
        this.selectedConferenceTypes.includes(agenda.type ? agenda.type.replace(/\s+/g, '-') : "");

    // Check session formats
    const isValidSessionFormat = this.selectedSessionFormats.length === 0 || 
        agenda.session_categories?.some(cat => 
            cat.options?.some(opt => this.selectedSessionFormats.includes(opt.id))
        );

    // Check categories
    const isValidCategory = this.selectedCategories.length === 0 ||
        agenda.session_categories?.some(cat =>
            cat.options?.some(opt => this.selectedCategories.includes(opt.id))
        );

    // Check tags
    const isValidTag = this.selectedTags.length === 0 ||
        agenda.session_categories?.some(cat =>
            cat.options?.some(opt => opt && this.selectedTags.includes(opt.id))
        );

    const isValidLocation = this.selectedRooms.length === 0 || 
        (this.selectedRooms.length === 0 || this.selectedRooms.includes(agenda.room ? agenda.room.replace(/\s+/g, '-') : ""));

    // Return true if all conditions are met
    return isValidType && isValidSessionFormat && isValidCategory && isValidTag && isValidLocation;
});
  //Apply search query filter
  if (this.searchQuery) {
    result = result.filter(agenda =>
      agenda.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
      (agenda.description && agenda.description.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
      (agenda.user && agenda.user.some(user => user.name.toLowerCase().includes(this.searchQuery.toLowerCase())))
    );
  }

  this.$store.dispatch("setFilteredagenda", result);
}
},


removeConferenceType(index) {
  // Get the type that is being removed
  //const typeToRemove = this.selectedConferenceTypes[index];

  // Remove the type from the selectedConferenceTypes array
  this.selectedConferenceTypes.splice(index, 1);

  // Reapply filters to update the view
  this.applyFilters();

  // // Create a new URLSearchParams object from the current URL
  // const queryParams = new URLSearchParams(window.location.search);

  // // Remove the type from the URL search parameters
  // queryParams.delete('conferencetype', this.capitalizeWords(typeToRemove).replace(/-/g, ''));

  // // Update the URL without reloading the page
  // history.pushState(null, '', `${window.location.pathname}?${queryParams.toString()}`);
},
  //   removeConferenceType(index) {
  //   this.selectedConferenceTypes.splice(index, 1);
  //   this.applyFilters(); // Reapply filters to update the view
  // },
  formatTagDisplay(value) {
    let optionLabel = value;
    this.filters.forEach(filter => {
      filter.categoryOptions.forEach(option => {
        if (option.option_id === value) {
          optionLabel = option.option_label;
        }
      });
    });
    return optionLabel.replace(/-/g, ' ');  // Replace all hyphens with spaces
  },
  formatDate(dateStr) {
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      const date = new Date(dateStr);
      const dayName = days[date.getDay()];
      const day = date.getDate();
      const monthName = months[date.getMonth()];

      return `${dayName} ${day} ${monthName}`;
    },
  // Method to remove selected category
  removeCategory(index) {
    //const typeToRemove = this.selectedCategories[index];
    this.selectedCategories.splice(index, 1);
    this.applyFilters(); // Reapply filters to update the view
  //   const queryParams = new URLSearchParams(window.location.search);

  // // Remove the type from the URL search parameters
  //   queryParams.delete('conferenceprogram', this.capitalizeWords(typeToRemove).replace(/-/g, ''));

  //   // Update the URL without reloading the page
  //   history.pushState(null, '', `${window.location.pathname}?${queryParams.toString()}`);
  },

  // Method to remove selected tag
  removeTag(index) {
    this.selectedTags.splice(index, 1);
    this.applyFilters(); // Reapply filters to update the view
  },
  removeRoom(index) {
    this.selectedRooms.splice(index, 1);
    this.applyFilters();
  },

  // New method to remove selected session format
  removeSessionFormat(index) {
    this.selectedSessionFormats.splice(index, 1);
    this.applyFilters();
  },
    navigateOnCheck(event, startDate) {
      if (event.target.checked) {
        const elementId = startDate.replace(/\//g, '-');
        // Check if there's any element with the ID equal to startDate
        const targetElement = document.getElementById(elementId);

        if (targetElement) {
          // Set the hash to the ID of the element, navigating the user to it
          this.isDayViewActive = true;
          targetElement.click();
          this.$router.push({ hash: '#' + elementId });
          //window.location.hash = elementId;
          event.target.checked = false;
          this.isLayoutfilterExpanded = window.innerWidth < 600;
        } else {
          console.error("No element found with ID:", startDate);
        }
        
      }
    },
    toggleView() {
      this.isDayViewActive = !this.isDayViewActive;
      this.isLayoutfilterExpanded = false;
      this.isPrimaryfilterExpanded = false;
      this.isSecondaryfilterExpanded = false;
      this.isTertiaryfilterExpanded = false;
    },
    updateSecondaryFilter(value) {
      const index = this.selectedConferenceTypes.indexOf(value);
      if (index > -1) {
        // If the value is already in the array, remove it (the checkbox was unchecked)
        this.selectedConferenceTypes.splice(index, 1);
      } else {
        // Otherwise, add the value to the array (the checkbox was checked)
        this.selectedConferenceTypes.push(value);
      }
    },
    updateSelectedCategory(value) {
      const index = this.selectedCategories.indexOf(value);
      if (index > -1) {
        // If the value is already in the array, remove it (the checkbox was unchecked)
        this.selectedCategories.splice(index, 1);
      } else {
        // Otherwise, add the value to the array (the checkbox was checked)
        this.selectedCategories.push(value);
      }
    },
    updateSelectedTags(value) {
      const index = this.selectedTags.indexOf(value);
      if (index > -1) {
        // If the value is already in the array, remove it (the checkbox was unchecked)
        this.selectedTags.splice(index, 1);
      } else {
        // Otherwise, add the value to the array (the checkbox was checked)
        this.selectedTags.push(value);
      }
    },
   
  updateSelectedSessionFormats(value) {
    const index = this.selectedSessionFormats.indexOf(value);
    if (index > -1) {
      this.selectedSessionFormats.splice(index, 1);
    } else {
      this.selectedSessionFormats.push(value);
    }
  },
    sortUsers(users) {
      // Sort the users array based on whether the user is a moderator or not
      return users.sort((a, b) => {
        // Moderators first
        if (a.isModerator && !b.isModerator) return -1;
        if (!a.isModerator && b.isModerator) return 1;
        // Then sort by other criteria if needed
        // Example: Sort by name if both users are moderators or both are not moderators
        return a.name.localeCompare(b.name);
      });
    },
    getDayOfMonth(startDate) {
      const startDateObj = new Date(startDate);
      return startDateObj.getDate();
    },
    getMonthName(startDate) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const startDateObj = new Date(startDate);
      return monthNames[startDateObj.getMonth()];
    },
    getRoomClassName(room) {
      if (room === "Theatre One") {
        return "theatre-one";
      } else if (room === "Theatre Two") {
        return "theatre-two";
      } else {
        return "theatre";
      }
    },
    chairpersons(user) {
      return user.filter((user) => user.role === "Chairperson");
    },
    speakers(user) {
      return user.filter((user) => user.role !== "Chairperson");
    },
    getUsersByRole(role) {
      return this.agenda.user.filter((user) => user.role === role);
    },
    formatTime(time) {
      // Assuming time is in format 'hh:mm AM/PM'
      const [hour, minute, period] = time.split(/:| /);
      let formattedHour = parseInt(hour, 10);

      if (period === "PM" && formattedHour !== 12) {
        formattedHour += 12;
      } else if (period === "AM" && formattedHour === 12) {
        formattedHour = 0;
      }

      return `${formattedHour.toString().padStart(2, "0")}:${minute}`;
    },

    getAllAgendaList(type) {
      this.selectedCategory = "all";
      this.$store.dispatch("agendaInitialList", type);
      /*this.categoryList.forEach((category) => {
        category.selected = false;
      });*/
    },

    getFilters(){
      this.$store.dispatch("getFilters");
    },
    stripHTML(html) {
      // Create a temporary element and set its innerHTML to the provided HTML
      const tempElement = document.createElement("div");
      tempElement.innerHTML = html;
      // Return the decoded HTML content
      return tempElement.textContent || tempElement.innerText || "";
    },

    /*for pop up*/
    getagendaDetailsById(publishedSessionId, slotId) {
      //this.$store.dispatch("agendaDetailsById", publishedSessionId,slotId);
      this.$store.dispatch("agendaDetailsById", { publishedSessionId, slotId });
      $(".multi-agenda-popup-wraper").addClass("active");
      $(".popup-welcome-note").addClass("blur-popup");
      setTimeout(function () {
        $(".popup-welcome-note").removeClass("blur-popup");
      }, 1000);
    },
    closeAgendaPopup() {
      $(".multi-agenda-popup-wraper").removeClass("active");
    },
    compareRooms(roomA, roomB) {
      const roomNumberA = this.extractRoomNumber(roomA);
      const roomNumberB = this.extractRoomNumber(roomB);

      // If both have room numbers, compare them numerically
      if (!isNaN(roomNumberA) && !isNaN(roomNumberB)) {
        return roomNumberA - roomNumberB;
      }

      // If one has a room number, prioritize it
      if (!isNaN(roomNumberA)) {
        return -1;
      } else if (!isNaN(roomNumberB)) {
        return 1;
      }

      // Compare alphabetically
      return (roomA || "").localeCompare(roomB || "");
    },

    // Helper function to extract room number from room name
    extractRoomNumber(room) {
      const match = (room || "").match(/\d+/);
      return match ? parseInt(match[0]) : NaN;
    },
    /*for fetching time based agenda
    groupAgendaByTimeold(agendaList) {
      let agendas = agendaList;
      const groups = {};
      if (agendas != null) {
        agendas.forEach(agenda => {
          //setting day state for date filter in intial load
          this.$store.state.dayState1 = agenda.earliestDate;

          let startTime = agenda.startDateTime;
          let room = agenda.room;
          console.log(room);
        if (!groups[startTime]) {
            groups[startTime] = [];
          }
          groups[startTime].push(agenda);
        });
        //return Object.values(groups);
        // Sort the groups by start time
        const sortedGroups = {};
        Object.keys(groups).sort().forEach(key => {
          sortedGroups[key] = groups[key];
        });
        return Object.values(sortedGroups);
      }
      return null;
    },*/

    groupAgendaByTime(agendaList) {
      let agendas = agendaList;
      const groups = {};

      if (agendas != null) {
        agendas.forEach((agenda) => {
          this.$store.state.dayState1 = agenda.earliestDate;
          let startTime = agenda.startDateTime;

          if (!groups[startTime]) {
            groups[startTime] = [];
          }
          groups[startTime].push(agenda);
        });

        // Sort agendas within each time group by both time and room
        Object.keys(groups).forEach((key) => {
          groups[key].sort((a, b) => {
            // First, sort by time
            const timeComparison = a.startDateTime.localeCompare(
              b.startDateTime
            );
            if (timeComparison !== 0) {
              return timeComparison;
            }

            // If times are equal, then sort by room using the custom comparator
            return this.compareRooms(a.room, b.room);
          });
        });

        // Sort the groups by start time
        const sortedGroups = {};
        Object.keys(groups)
          .sort()
          .forEach((key) => {
            sortedGroups[key] = groups[key];
          });

        return Object.values(sortedGroups);
      }

      return null;
    },
    getAgendaByDay(agendaList, specificDate) {
      const groups = {};

      if (!agendaList) {
        console.log("Agenda list is not available.");
        return []; // Return an empty array to avoid errors when trying to use .filter
      }
      // Filter and process only agendas matching the specific date
      let filteredAgendas = agendaList.filter(agenda => agenda.startDate === specificDate);
      if (filteredAgendas.length > 0) {
        filteredAgendas.forEach((agenda) => {
          let dayDate = agenda.startDate;

          if (!groups[dayDate]) {
            groups[dayDate] = [];
          }
          groups[dayDate].push(agenda);
        });

        // Sort agendas within each day group by time and possibly by room
        Object.keys(groups).forEach((key) => {
          groups[key].sort((a, b) => {
            const timeComparison = new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime();
            if (timeComparison !== 0) {
              return timeComparison;
            }
            // Optionally sort by other criteria such as room
            return 0; // Modify or remove based on actual needs
          });
        });

        return Object.values(groups);
      }

      // Return empty array if no agendas match the specific date
      return [];
    },



    /*intial categiry list*/
     getAllCategoryList() {
      //debugger
       axios
        .get(url.category_list_api)
        .then((response) => {
          //debugger
          this.categoryList = response.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    getAllDayList(type) {
      //debugger
      axios
        .get(url.date_list_api(type))
        .then((response) => {
          (this.days = response.data),
            (this.activeDay = this.days[0])
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    toggleSessionFormatFilter() {
      if (this.hasSessionFormats) {
      this.isSessionFormatExpanded = !this.isSessionFormatExpanded;
    }
  },
    toggleTertiaryfilter() {
      this.isTertiaryfilterExpanded = !this.isTertiaryfilterExpanded; // Toggle the state of isLocationExpanded
    },
    togglePrimaryfilter() {
      this.isPrimaryfilterExpanded = !this.isPrimaryfilterExpanded; // Toggle the state of isLocationExpanded
    },
    toggleLayoutfilter() {
      this.isLayoutfilterExpanded = !this.isLayoutfilterExpanded; // Toggle the state of isLocationExpanded
    },
    toggleSecondaryfilter() {
      this.isSecondaryfilterExpanded = !this.isSecondaryfilterExpanded; // Toggle the state of isLocationExpanded

    },
    showAgendaByCategoryAndDay: function (categoryName) {
      // debugger
      let selectedDayValue = this.$store.state.dayState;
      if (selectedDayValue == null) {
        selectedDayValue = this.$store.state.dayState1;
      }
      const objCategoryAndDay = {
        categoryName: categoryName,
        selectedDayValue: selectedDayValue,
      };
      this.$store.dispatch("agendaFilterByCategoryAndDay", objCategoryAndDay);
      if (this.selectedCategory !== categoryName) {
        this.selectedCategory = categoryName;
      }
    },
    showAgendaByDay: function (selectedDay) {
      //debugger

      this.activeDay =  this.days && this.days.find((day) => day.startDate === selectedDay);
      //console.log(this.activeDay);
      //let day = this.days[0] === this.days[0] ? 1 : 2;
      //console.log(day)
      //const body = document.getElementsByClassName('active-bar');
      //body[0].classList.remove("tc-agenda-day-active");
      // body[1].classList.remove("tc-agenda-day-active");
      // document.getElementById(selectedDay).className = "test tc-agenda-day-active";
      this.$store.state.dayState = selectedDay;
      return this.$store.dispatch("agendaFilterByDay", selectedDay);
    },
    downloadICalendar() {
      // Build iCalendar content dynamically using Vue data
      const icalContent = `
BEGIN:VCALENDAR
PRODID:-//Microsoft Corporation//Outlook 11.0 MIMEDIR//EN
VERSION:2.0
METHOD:PUBLISH
BEGIN:VEVENT
DTSTART:${this.formatDateTime(this.startDate, this.startTime)}
DTEND:${this.formatDateTime(this.startDate, this.endTime)}
LOCATION;ENCODING=QUOTED-PRINTABLE:${this.room}
TRANSP:OPAQUE
SEQUENCE:0
UID:${this.uid}
DTSTAMP:${this.formatDateTime(new Date())}
DESCRIPTION:${this.description}
SUMMARY:${this.companyName}
PRIORITY:5
CLASS:PUBLIC
BEGIN:VALARM
TRIGGER:PT1W
ACTION:DISPLAY
DESCRIPTION:Reminder
END:VALARM
END:VEVENT
END:VCALENDAR`;

      // Create a Blob with the iCalendar content
      const blob = new Blob([icalContent], {
        type: "text/calendar;charset=utf-8",
      });

      // Create a download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "calendar.ics";

      // Append the link to the document and trigger a click event to start the download
      document.body.appendChild(link);
      link.click();

      // Clean up the temporary link element
      document.body.removeChild(link);
    },

    formatDateTime(date, time) {
      try {
        const dateTimeString = `${date}T${time}`;
        // Split the input date and time string
        const [datePart, timePart] = dateTimeString.split("T");
        const [month, day, year] = datePart.split("/");
        const [time1, meridiem] = timePart.split(" ");

        // Convert 12-hour time to 24-hour time
        let [hours, minutes] = time1.split(":");
        hours =
          (parseInt(hours, 10) % 12) +
          (meridiem.toUpperCase() === "PM" ? 12 : 0);

        // Pad single-digit values with leading zeros
        const formattedDateTime = `${year}${month.padStart(
          2,
          "0"
        )}${day.padStart(2, "0")}T${hours
          .toString()
          .padStart(2, "0")}:${minutes.padStart(2, "0")}:00`;

        return formattedDateTime;
      } catch (error) {
        console.error("Error formatting date and time:", error.message);
        return ""; // Handle invalid input by returning an empty string or another default value
      }
    },
    removeNbsp(text) {
      // Replace &nbsp; with an empty string
      return text.replace(/&nbsp;/g, "");
    },
  },
};
</script>

<style scoped>

/* Add your custom styles here */
.expanded {
  display: block;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.rotate {
  transform: rotate(180deg);
  transition: transform 0.3s ease-in-out;
}

.filter-tag {
  padding: 2px 8px;
  background-color: #e4e4e4;
  border-radius: 8px;
  display: inline-block;
  margin-right: 5px;
}

.close-icon {
  margin-left: 8px;
  cursor: pointer;
  color: red;
}

</style>
